import { render, staticRenderFns } from "./EditBuildingTechnicalFeatures.vue?vue&type=template&id=00d97609"
import script from "./EditBuildingTechnicalFeatures.vue?vue&type=script&lang=js"
export * from "./EditBuildingTechnicalFeatures.vue?vue&type=script&lang=js"
import style0 from "./EditBuildingTechnicalFeatures.vue?vue&type=style&index=0&id=00d97609&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports